import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition } from "vue";
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import i18n from '@/i18n-config';
import Router from '@/router';
import useShellFooter from '@/composables/global/use-shell-footer';
import { errorAlert } from '@/utils/ion-alert';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheShellFooter',
  setup(__props) {
    const {
      t
    } = useI18n({
      useScope: 'global',
      messages: {
        en: {
          TheShellFooter: {
            next: 'Next',
            previous: 'Previous'
          }
        },
        es: {
          TheShellFooter: {
            next: 'Siguiente',
            previous: 'Anterior'
          }
        }
      }
    });
    const {
      isFooterVisible,
      levelPageActions,
      levelPageProgress,
      navNextDelayCountdown,
      navNextDisabled,
      showNavPrevious,
      tabItems
    } = useShellFooter();
    const isBrushTool = computed(() => {
      return Router.currentRoute.value.name === 'BrushTool';
    });
    const isCallPage = computed(() => {
      return Router.currentRoute.value.name === 'CallPage';
    });
    const isLevelPage = computed(() => {
      return Router.currentRoute.value.name === 'LevelPage';
    });
    const isReachableNextStep = computed(() => {
      return Router.currentRoute.value.name === 'ReachableNextStepPage';
    });
    const currentViewHasFooter = computed(() => {
      return isBrushTool.value || isLevelPage.value || isReachableNextStep.value || isCallPage.value;
    });
    const formattedCountdownTime = computed(() => {
      if (!navNextDelayCountdown.value) return '0:00';
      const minutes = Math.floor(navNextDelayCountdown.value / 60);
      const seconds = navNextDelayCountdown.value % 60;
      if (seconds < 10) {
        return `${minutes}:0${seconds}`;
      }
      return `${minutes}:${seconds}`;
    });
    function navPrevious() {
      try {
        var _levelPageActions$nav;
        levelPageActions === null || levelPageActions === void 0 || (_levelPageActions$nav = levelPageActions.navPrevious) === null || _levelPageActions$nav === void 0 || _levelPageActions$nav.call(levelPageActions);
      } catch (error) {
        errorAlert({
          error
        });
      }
    }
    function navNext() {
      if (navNextDisabled.value) return;
      try {
        var _levelPageActions$nav2;
        levelPageActions === null || levelPageActions === void 0 || (_levelPageActions$nav2 = levelPageActions.navNext) === null || _levelPageActions$nav2 === void 0 || _levelPageActions$nav2.call(levelPageActions);
      } catch (error) {
        errorAlert({
          error
        });
      }
    }
    return (_ctx, _cache) => {
      const _component_ion_progress_bar = _resolveComponent("ion-progress-bar");
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_label = _resolveComponent("ion-label");
      const _component_ion_item = _resolveComponent("ion-item");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_toolbar = _resolveComponent("ion-toolbar");
      const _component_ion_tab_button = _resolveComponent("ion-tab-button");
      const _component_ion_tab_bar = _resolveComponent("ion-tab-bar");
      const _component_ion_footer = _resolveComponent("ion-footer");
      return _openBlock(), _createBlock(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [_withDirectives(_createVNode(_component_ion_footer, null, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_ion_progress_bar, {
            color: "progress-bar",
            value: _unref(levelPageProgress),
            class: "default-background"
          }, null, 8, ["value"]), [[_vShow, isLevelPage.value]]), _withDirectives(_createVNode(_component_ion_toolbar, {
            color: "menu",
            class: "border-top"
          }, {
            default: _withCtx(() => [isCallPage.value ? (_openBlock(), _createBlock(_component_ion_item, {
              key: 0,
              lines: "none"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_icon, {
                color: "primary",
                name: "information-circle-outline",
                slot: "start"
              }), _createVNode(_component_ion_label, {
                color: "primary",
                class: "ion-text-wrap"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(i18n).global.t('Call.recordingCall')), 1)]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_ion_button, {
              onClick: navPrevious,
              slot: "start",
              fill: "solid"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_icon, {
                icon: "caret-back"
              }), _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('TheShellFooter.previous')), 1)]),
                _: 1
              })]),
              _: 1
            }, 512), [[_vShow, _unref(showNavPrevious) && isReachableNextStep.value]]), _withDirectives(_createVNode(_component_ion_button, {
              onClick: navNext,
              slot: "end",
              fill: "solid",
              disabled: _unref(navNextDisabled)
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_label, null, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('TheShellFooter.next')), 1)]),
                _: 1
              }), _createVNode(_component_ion_icon, {
                icon: "caret-forward"
              })]),
              _: 1
            }, 8, ["disabled"]), [[_vShow, isReachableNextStep.value]]), _withDirectives(_createVNode(_component_ion_button, {
              onClick: navPrevious,
              slot: "start",
              fill: "solid"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_label, null, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('TheShellFooter.previous')), 1)]),
                _: 1
              }), _createVNode(_component_ion_icon, {
                icon: "caret-back",
                slot: "start"
              })]),
              _: 1
            }, 512), [[_vShow, isLevelPage.value]]), _withDirectives(_createVNode(_component_ion_button, {
              onClick: navNext,
              slot: "end",
              fill: "solid",
              disabled: _unref(navNextDisabled) || !!_unref(navNextDelayCountdown)
            }, {
              default: _withCtx(() => [_unref(navNextDelayCountdown) ? (_openBlock(), _createBlock(_component_ion_label, {
                key: 0
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(formattedCountdownTime.value), 1)]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_ion_label, {
                key: 1
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('TheShellFooter.next')), 1)]),
                _: 1
              })), _createVNode(_component_ion_icon, {
                icon: "caret-forward",
                slot: "end"
              })]),
              _: 1
            }, 8, ["disabled"]), [[_vShow, isLevelPage.value]])]),
            _: 1
          }, 512), [[_vShow, isCallPage.value || isLevelPage.value || isReachableNextStep.value]]), _withDirectives(_createVNode(_component_ion_tab_bar, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabItems), item => {
              return _openBlock(), _createBlock(_component_ion_tab_button, {
                key: item.id,
                tab: item.id,
                href: item.href
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_icon, {
                  icon: item.icon
                }, null, 8, ["icon"]), _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["tab", "href"]);
            }), 128))]),
            _: 1
          }, 512), [[_vShow, isBrushTool.value]])]),
          _: 1
        }, 512), [[_vShow, currentViewHasFooter.value && _unref(isFooterVisible)]])]),
        _: 1
      });
    };
  }
});